module.exports = __webpack_public_path__ + "profile.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pictures/profile.png
// module id = 115
// module chunks = 0